export const getGrowDomain = () => 'https://grow.almabetter.com/';
export const getDomainName = () => 'www.almabetter.com';
export const getGrowSignupUrl = () => getGrowDomain() + 'auth/signup';

export const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

export const nameRegex = /^[a-z ,.'-]+$/i;
